import Api from "shared/service/api/api";

//actions
export const LOAD_REQUEST_LIST = "loadRequestList";

//mutations
export const SET_REQUEST_LIST = "setVerifyList";

const state = {
  requests: {
    list: [],
    page: 1,
    page_count: 1,
  },
  datasets: {
    states: [
      { id: "", label: "Все" },
      { id: "1", label: "Новые" },
      { id: "2", label: "Одобренные" },
      { id: "3", label: "Отклоненные" },
    ],
  },
};

const actions = {
  [LOAD_REQUEST_LIST]({ commit }, { page, status = "" }) {
    Api.verify
      .all(page, status)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_REQUEST_LIST, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_REQUEST_LIST](state, { list, page, page_count }) {
    state.requests.list = list.map((request) => {
      request.full_name = request.first_name + " " + request.last_name;
      return request;
    });
    state.requests.page = page;
    state.requests.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
